import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-talk",
  "use": "icon-talk-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-talk\">\n    <g fill=\"none\" fill-rule=\"evenodd\" opacity=\".6\" transform=\"translate(4 2)\">\n        <path fill=\"#000\" d=\"M5 19H11V20H5z\" />\n        <rect width=\"9\" height=\"14\" x=\"3.5\" y=\".5\" stroke=\"#000\" rx=\"4.5\" />\n        <path stroke=\"#000\" d=\"M9.5 17.902V19.5h-3v-1.598h3zM16 11c-.718 3.929-4.027 6.899-8.001 6.899-3.97 0-7.277-2.965-7.999-6.888\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol